// RegExp that is used by IB to validate email (must be used as CASE INSENSITIVE)
const EMAIL_REG_EXP =
  /^[A-Z0-9][A-Z0-9._%+-]{0,63}@(?:(?=[A-Z0-9-]{1,63}[.])[A-Z0-9]+(?:-[A-Z0-9]+)*[.]){1,8}[A-Z]{2,63}$/i;

export const isEmailValid = (email: string): boolean => email.match(EMAIL_REG_EXP) !== null;
